<h4>Séance</h4>
<div class="row" [formGroup]="form()">
    <div class="col-12 row mb-3">
        <div class="d-flex flex-column col-6">
            <label class="input-label">Type(s) de séance</label>
            <p-multiSelect formControlName="meetingTypes" [placeholder]="'Sélectionner un ou plusieurs types de séance'"
                [optionLabel]="'description'" [appendTo]="'body'" [style]="{width: '100%'}"
                [disabled]="fetchingMeetingTypes()" [loading]="fetchingMeetingTypes()"
                [options]="meetingTypesOptions()"></p-multiSelect>
        </div>
        <div class="d-flex flex-column col-6">
            <label class="input-label">Séance(s)</label>
            <p-multiSelect formControlName="meetings" [disabled]="!canSelectMeetings() || fetchingMeetings()"
                [loading]="fetchingMeetings()" [placeholder]="meetingsPlaceholder" [appendTo]="'body'"
                [optionLabel]="'description'" [style]="{width: '100%'}" [options]="meetingsOptions()"></p-multiSelect>
        </div>
    </div>
    <div class="col-12 row">
        <label class="input-label">Date</label>
        <div class="d-flex date-range">
            <button (click)="switchDateFormat()" pButton id="date-toggler">
                {{dateFormat() === 'single' ? 'Date unique' : 'Période de dates'}}
            </button>
            <!--Selection Mode Input Bug, impossible to populate, workaround implemented-->
            @if(dateFormat() === 'range') {
            <p-calendar [appendTo]="'body'" [style]="{width: '100%'}" [dateFormat]="'dd/mm/yy'" formControlName="date"
                id="date-picker" [selectionMode]="'range'"></p-calendar>

            }@else {
            <p-calendar [appendTo]="'body'" [style]="{width: '100%'}" [dateFormat]="'dd/mm/yy'" formControlName="date"
                id="date-picker" [selectionMode]="'single'"></p-calendar>
            }
        </div>
    </div>
</div>